import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import TutorDashboard from "./TutorDashboard";
import WaitingRoom from "./WaitingRoom";
import AdminDashboard from "./AdminDashboard";
import RoleGuard from "../context/RoleGuard";
import { Box, CircularProgress } from "@mui/material";

export default function DashboardRouter() {
  const { profile, loading } = useAuth();

  if (loading || !profile)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );

  if (profile.status !== "approved") return <WaitingRoom />;

  if (
    profile.role === "admin" ||
    profile.role === "coordinator" ||
    profile.role === "viewer"
  )
    return (
      <RoleGuard allowedRoles={["admin", "coordinator", "viewer"]}>
        <AdminDashboard />
      </RoleGuard>
    );
  if (profile.role === "tutor")
    return (
      <RoleGuard allowedRoles={["tutor"]}>
        <TutorDashboard />
      </RoleGuard>
    );

  // Safe fallback
  return <Navigate to="/" replace />;
}
